// extracted by mini-css-extract-plugin
export default {"text":"tableDataCell_text__3Hup4","unclampText":"tableDataCell_unclampText__djLv2","readMore":"tableDataCell_readMore__0lt9E"};